import { render } from "./Provinces.vue?vue&type=template&id=b0c88276"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__